import images from '@assets/images/index'
import { memo } from 'react'

import { Database_Procs_GetPlayerQuest_Item } from '@suntex.fim/api-client'

// Quest icon grids organized by categories
const stickerQuestGrid: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>> | React.ComponentType
> = {
  'stickers-1000': images.Sticker1000,
  'stickers-2000': images.Sticker2000,
  'stickers-3000': images.Sticker3000,
  'stickers-4000': images.Sticker4000,
  'stickers-5000': images.Sticker5000,
  'stickers-6000': images.Sticker6000,
  'stickers-8000': images.Sticker8000,
  'stickers-10000': images.Sticker10000
}
const skillSetsGrid: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>> | React.ComponentType
> = {
  'complete-ss1': images.CompleteSs1,
  'complete-ss2': images.CompleteSs2,
  'complete-ss3': images.CompleteSs3,
  'complete-ss4': images.CompleteSs4,
  'complete-ss5': images.CompleteSs5,
  'complete-ss6': images.CompleteSs6,
  'complete-ss7': images.CompleteSs7,
  'complete-ss8': images.CompleteSs8
}
const jftGrid: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>> | React.ComponentType
> = {
  'complete-jtf-num-pre': images.CompleteJTFNumPre,
  'complete-jtf-frc-pre': images.CompleteJTFFrcPre,
  'complete-jtf-dec-pre': images.CompleteJTFDecPre,
  'complete-jtf-int-pre': images.CompleteJTFIntPre,
  'complete-jtf-num-post': images.CompleteJTFNumPost,
  'complete-jtf-frc-post': images.CompleteJTFFrcPost,
  'complete-jtf-dec-post': images.CompleteJTFDecPost,
  'complete-jtf-int-post': images.CompleteJTFIntPost
}
const gymAddSubGrid: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>> | React.ComponentType
> = {
  'complete-gym-num-add': images.CompleteGymNumAdd,
  'complete-gym-num-sub': images.CompleteGymNumSub,
  'complete-gym-num-mul': images.CompleteGymNumMul,
  'complete-gym-num-div': images.CompleteGymNumDiv,
  'complete-gym-frc-add': images.CompleteGymFrcAdd,
  'complete-gym-frc-sub': images.CompleteGymFrcSub,
  'complete-gym-frc-mul': images.CompleteGymFrcMul,
  'complete-gym-frc-div': images.CompleteGymFrcDiv
}
const gymMulDivGrid: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>> | React.ComponentType
> = {
  'complete-gym-dec-add': images.CompleteGymDecAdd,
  'complete-gym-dec-sub': images.CompleteGymDecSub,
  'complete-gym-dec-mul': images.CompleteGymDecMul,
  'complete-gym-dec-div': images.CompleteGymDecDiv,
  'complete-gym-int-add': images.CompleteGymIntAdd,
  'complete-gym-int-sub': images.CompleteGymIntSub,
  'complete-gym-int-mul': images.CompleteGymIntMul,
  'complete-gym-int-div': images.CompleteGymIntDiv
}
const milestonesAndGamesGrid: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>> | React.ComponentType
> = {
  'kas-3-milestone-3': images.Kas3Milestone3,
  'kas-3-milestone-5': images.Kas3Milestone5,
  'kas-3-milestone-7': images.Kas3Milestone7,
  'kas-3-milestone-9': images.Kas3Milestone9,
  'kas-5-milestone-3': images.Kas5Milestone3,
  'kas-5-milestone-5': images.Kas5Milestone5,
  'kas-5-milestone-7': images.Kas5Milestone7,
  'kas-5-milestone-9': images.Kas5Milestone9
}
const specialQuestsGrid: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>> | React.ComponentType
> = {
  'max-bonus-game': images.MaxBonusGame,
  'complete-kas-2-2': images.Sticker1000,
  'complete-jtf': images.CompleteJTFIntPost,
  'complete-gym': images.CompleteGymIntDiv,
  'complete-kas': images.Kas5Milestone9,
  'complete-ss': images.CompleteSs8,
  'complete-10-bonus': images.Complete10Bonus,
  'complete-10-mw': images.Complete10Mw
}
const measurementWorldGrid: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>> | React.ComponentType
> = {
  'complete-mw-game': images.CompleteMwGame
}
const bonusGameGrid: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>> | React.ComponentType
> = {
  'complete-bonus-game': images.CompleteBonusGame
}
const winPotd: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>> | React.ComponentType
> = {
  'win-potd': images.WinPotd
}
const topTen: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>> | React.ComponentType
> = {
  'top-ten': images.TopTen
}
const sticker200Week: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>> | React.ComponentType
> = {
  'stickers-200-week': images.Sticker200
}
const completeCtGame: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>> | React.ComponentType
> = {
  'complete-ct-game': images.CompleteCtGame
}
const tryOnEpic: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>> | React.ComponentType
> = {
  'try-rps-epic': images.TryRps
}

// Combined quest icon mapping (supports SVG and custom components)
const questIconMap: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>> | React.ComponentType
> = {
  ...stickerQuestGrid,
  ...skillSetsGrid,
  ...jftGrid,
  ...gymAddSubGrid,
  ...gymMulDivGrid,
  ...milestonesAndGamesGrid,
  ...specialQuestsGrid,
  ...measurementWorldGrid,
  ...bonusGameGrid,
  ...winPotd,
  ...topTen,
  ...sticker200Week,
  ...completeCtGame,
  ...tryOnEpic,

  // Default fallback
  default: images.Sticker200
}

/**
 * Get the appropriate SVG icon component based on quest slug
 * @param slug - The quest slug identifier
 * @returns React SVG component
 */
const getSvgIcon = (
  slug: string | undefined
): React.ComponentType<React.SVGProps<SVGSVGElement>> => {
  if (!slug) return questIconMap.default

  // Convert slug to lowercase and check for direct match
  const normalizedSlug = slug.toLowerCase()
  if (questIconMap[normalizedSlug]) {
    return questIconMap[normalizedSlug]
  }

  // Check for partial matches (useful for complex slug patterns)
  const partialMatch = Object.keys(questIconMap).find(
    (key) => normalizedSlug.includes(key) || key.includes(normalizedSlug)
  )

  return partialMatch ? questIconMap[partialMatch] : questIconMap.default
}

export interface DynamicSvgIconProps {
  /** Quest object containing slug and questName */
  quest?: Pick<Database_Procs_GetPlayerQuest_Item, 'slug' | 'questName'>
  /** Optional quest slug if quest object is not available */
  slug?: string
  /** Optional quest name for aria-label if quest object is not available */
  questName?: string
  /** Custom style for the icon */
  style?: React.CSSProperties
  /** Custom className for the icon */
  className?: string
  /** Custom aria-label (defaults to questName + " icon") */
  ariaLabel?: string
}

/**
 * DynamicSvgIcon - A reusable component for rendering dynamic SVG icons
 *
 * Features:
 * - Dynamic SVG selection based on quest slug or custom slug
 * - Comprehensive icon mapping for different quest types
 * - Intelligent fallback system with partial matching
 * - Customizable styling and sizing
 * - Accessibility support with proper aria-labels
 * - Optimized with React.memo for performance
 *
 * @param props - The component props
 * @returns JSX element
 */
function DynamicSvgIcon({
  quest,
  slug,
  questName,
  style,
  className,
  ariaLabel
}: DynamicSvgIconProps) {
  // Determine the slug and name from props
  const iconSlug = quest?.slug || slug
  const name = quest?.questName || questName || 'Icon'

  // Get the appropriate icon component
  const IconComponent = getSvgIcon(iconSlug)

  // Prepare styles
  const iconStyle: React.CSSProperties = {
    ...style
  }

  // Prepare aria-label
  const label = ariaLabel || `${name} icon`

  return (
    <IconComponent
      style={iconStyle}
      className={className}
      aria-label={label}
      role="img"
    />
  )
}

export default memo(DynamicSvgIcon)
